import { Component, forwardRef } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';
import { FinancialServiceOpenQuoteWrapper } from '@app/pages/quote/open-quote/financial-service/financial-service-wrapper.component';

@Component({
  selector: 'app-financial-service',
  templateUrl: './financial-service.component.html',
  styleUrls: ['./financial-service.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FinancialServiceComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => FinancialServiceComponent),
      multi: true,
    },
  ],
})
export class FinancialServiceComponent extends FinancialServiceOpenQuoteWrapper {
  constructor(
    route: ActivatedRoute,
    menu: MenusServices,
    notification: NotificationService
  ) {
    super(route, menu, notification);
  }
}
